import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { addFieldPrefix } from '../utils';
import { DataMappingValues } from '../dataMapping/DataMappingForm';
import { TemplateOptionsValues } from '../TemplatesOptionsForm';
import { TemplateFormValues } from '../types';

export const useInitialValues = (templateId: string): { data: TemplateFormValues; isFetching: boolean } => {
    const { data: templateDetailData, isFetching } = useRepositorySuspenseQuery(
        'reservationContractTemplates',
        'getDetail',
        {
            id: templateId,
        }
    );

    const templateOptionsFields: TemplateOptionsValues = {
        name: templateDetailData.name,
        description: templateDetailData.description,
        services: templateDetailData.services.map((service) => service.id),
        template: templateDetailData.externalTemplateId,
    };

    const dataMappingFields: DataMappingValues = templateDetailData.files
        .flatMap((file) => file.fieldMappings || [])
        .reduce(
            (acc: DataMappingValues, field) => ({
                ...acc,
                [addFieldPrefix(field.externalFieldId)]: field.identifier,
            }),
            {}
        );

    return {
        data: {
            templateOptionsFields,
            dataMappingFields,
        },
        isFetching,
    };
};
